<p-table

  [columns]="headers"
  [styleClass]="'btable'"
  [value]="tiers"
  id="fee-table"
>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th class="fee-sch-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns">
        {{col.header}}
      </th>
    </tr>
  </ng-template>

  
    <ng-template pTemplate="body" class="fee-sch-tbl-body" let-tier>
      <tr [ngClass]="disabled != false ? 'feeReadOnly' : null">
        <td>{{tier.label}}</td>
        <td>{{tier.monthlyFee | currency:'':'':'1.0-0'}}</td>
        <td>{{tier.queryAllowance | number}}</td>
        <td>{{tier.overageCharge| currency}}</td>
        <td>
          <p-radioButton [disabled]="disabled" name="fee-schedule-radio" value={{tier.tierName}} [ngModel]="selectedTier"
                         (onClick)="onTierChange(tier.tierName)" styleClass="fee-radio-button"></p-radioButton>
        </td>
      </tr>
    </ng-template>

</p-table>
<div class="mb-5" >
  <small i18n>The monthly fee covers the number of TNs, Blocks, and/or Codes returned, up to the allowance. Overage charges apply for each additional TN, Block, and/or Code returned above the allowance.</small>
</div>
